module.exports = __webpack_public_path__ + "img/ft2.a40676ab.svg";